/**
 * @file Automatically generated by barrelsby.
 */

export * from './injection-service';
